import { render, staticRenderFns } from "./Report-inventory.vue?vue&type=template&id=13a23f6e"
import script from "./Report-inventory.vue?vue&type=script&lang=js"
export * from "./Report-inventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports